import { useQuery } from 'react-query';

export default (id) => {
  const { data, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/video_session_tokens/${id}`, {}]);
  const sessionData = data?.data?.attributes;
  if (sessionData) {
    sessionData.adracareSessionToken = data.data.id;
  }
  return { data: sessionData, isLoading, isFetching: isLoading, total: data?.data?.meta?.total, isSuccess };
};
